import { Component, EventEmitter, Input, Output } from "@angular/core";
import { Router } from "@angular/router";
import Swal from "sweetalert2";

import PNotify from "pnotify/dist/es/PNotify";
import PNotifyButtons from "pnotify/dist/es/PNotifyButtons";

import { Discussion } from "../../../../../models";
import { DiscussionVoteService, UserService } from "../../../../../services";

@Component({
  selector: "upvote-discussion-button",
  templateUrl: "./upvote-discussion-button.component.html",
  styleUrls: [
    "./upvote-discussion-button.component.scss",
    "../../../../../../../assets/icon/icofont/css/icofont.scss",
  ],
})
export class UpvoteDiscussionButtonComponent {
  @Input() discussion: Discussion;
  @Output() onToggle = new EventEmitter<boolean>();
  public isSubmitting = false;

  constructor(
    private discussionVoteService: DiscussionVoteService,
    private router: Router,
    private userService: UserService
  ) {
    this.initializePNotify();
  }

  ngOnInit() {}

  public toggleUpvote(): void {
    if (this.discussion.community.isMember === true) {
      this.voteDiscussion();
    } else {
      this.openNonMemberAlert();
    }
  }

  public voteDiscussion() {
    this.isSubmitting = true;

    this.userService.isAuthenticated.subscribe((authenticated) => {
      // Not authenticated? Push to login screen
      if (!authenticated) {
        this.router.navigateByUrl("/login");
        return;
      }

      // Upvote the discussion if it isn't upvoted yet
      if (this.discussion.voted !== null && !this.discussion.voted.upVote) {
        this.updateVote(true);
      }
      // Otherwise,reverse the upvote of the discussion
      else {
        this.updateVote(false);
      }
    });
  }

  public updateVote(emitValue: boolean) {
    this.discussionVoteService.upvote(this.discussion).subscribe(
      (data) => {
        this.isSubmitting = false;
        this.onToggle.emit(emitValue);
        this.notifyUser();
      },
      (err) => (this.isSubmitting = false)
    );
  }

  public openNonMemberAlert() {
    Swal.fire({
      title: "Askies, Sorry!",
      text: "Only members of this uMuzi can vote on nDabas, please ask a member to invite you",
      type: "info",
      confirmButtonColor: "#3085d6",
      confirmButtonText: "Mxm ok!",
    });
  }

  public initializePNotify() {
    PNotifyButtons; // Initiate the module. Important!
    PNotify.defaults.styling = "bootstrap4"; // Bootstrap version 4
    PNotify.defaults.icons = "fontawesome4"; // Font Awesome 4
  }

  public notifyUser() {
    PNotify.info({
      title: "Hey!",
      titleTrusted: false,
      text: this.discussion.voted.upVote
        ? "You upvoted: " + this.discussion.slug.substring(0, 50) + "..."
        : "You reversed an upvote: " +
          this.discussion.slug.substring(0, 50) +
          "...",
      textTrusted: false,
      icon: "fa fa-bell",
      Mobile: {
        swipeDismiss: true,
        styling: true,
      },
      width: "300px",
      delay: 3000,
      buttons: { closer: true, labels: { close: "Fechar", stick: "Manter" } },
      stack: {
        dir1: "down",
        firstpos1: 25,
      },
    });
  }
}
